export default "__VITE_ASSET__Dw$ErUbC__"